import { validatorRegistry } from "./validatorRegistry";

validatorRegistry.registerFieldType(
  ["string", "email", "anzsic-code", "radio-button", "select", "card-select"],
  (subject) => subject.string().trim()
);

validatorRegistry.registerFieldType("address", (subject) => subject.object());

validatorRegistry.registerFieldType("checkbox", (subject) => subject.mixed());

validatorRegistry.registerFieldType("date", (subject) => subject.date().nullable());

validatorRegistry.registerFieldType("boolean", (subject) => subject.boolean());

validatorRegistry.registerFieldType(["integer", "revenue", "currency"], (subject) =>
  subject
    .number()
    .nullable()
    .transform((value, originalValue) =>
      String(originalValue).trim() === "" ? null : value
    )
    .integer("Must be a whole number")
);
